<h2 mat-dialog-title>{{ 'CONTACT_SALESPERSON.CONTACT' | translate }} Vendasta</h2>

<mat-dialog-content>
  <div class="dialog-content">
    <div class="salesperson-container row">
      <div>
        <img src="{{ imgUrl }}" />
      </div>
      <div class="contact-container">
        <div class="person-name">{{ name }}</div>
        <div class="person-title">{{ title }}</div>
        <div class="person-away-message">{{ awayMessage$ | async }}</div>
        <ng-container *ngIf="bookMeetingUrl$ | async as bookMeetingUrl; else phoneOnly">
          <div class="schedule-or-call">
            <a href="{{ bookMeetingUrl }}" target="_blank" class="schedule">
              {{ 'CONTACT_SALESPERSON.SCHEDULE_MEETING' | translate }}
            </a>
            <span class="or-call-text">&nbsp;{{ 'CONTACT_SALESPERSON.OR_CALL' | translate }}&nbsp;</span>
            <span class="contact-details">
              <a href="tel:{{ tel }}">
                {{ tel | formatPhoneNumber: countryCode }}
              </a>
            </span>
          </div>
        </ng-container>
        <ng-template #phoneOnly>
          <div class="contact-details">
            <div>
              <a href="tel:{{ tel }}">
                {{ tel | formatPhoneNumber: countryCode }}
              </a>
            </div>
          </div>
        </ng-template>
        <div *ngIf="canAccessInbox$ | async" class="send-message">
          <inbox-button-send-message
            [config]="{
              currentParticipant: currentIAMParticipant$ | async,
              subjectParticipants: subjectParticipants$ | async,
              channel: conversationChannel
            }"
            (closeModal)="close()"
          ></inbox-button-send-message>
        </div>
      </div>
    </div>
    <mat-form-field *ngIf="(canAccessInbox$ | async) === false" class="contact-text-area">
      <textarea
        class="sales-message-text"
        matInput
        cdkFocusInitial
        [(ngModel)]="message"
        (ngModelChange)="enableSend()"
        placeholder="{{ 'COMMON.ACTION_LABELS.COMPOSE_MESSAGE' | translate }}"
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="10"
        maxlength="500"
      ></textarea>
      <mat-hint align="end">{{ message.length }} / 500</mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="(canAccessInbox$ | async) === false">
  <button mat-stroked-button (click)="close()">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button *ngIf="!buttonEnabled; else activeButton" mat-flat-button color="primary">
    {{ 'COMMON.ACTION_LABELS.SEND' | translate }}
  </button>
  <ng-template #activeButton>
    <button *ngIf="sending; else buttonWithText" mat-stroked-button>
      <span>
        <mat-progress-spinner mode="indeterminate" diameter="24" color="accent"></mat-progress-spinner>
      </span>
    </button>
    <ng-template #buttonWithText>
      <button mat-flat-button color="primary" (click)="send()">
        {{ 'COMMON.ACTION_LABELS.SEND' | translate }}
      </button>
    </ng-template>
  </ng-template>
</mat-dialog-actions>
